import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClassBookingService, DeletePersonalTrainingSubscriptionTeacherService, DeletePersonalTrainingSubscriptionTeacherTimeTableService, GetPersonalTrainingSubscriptionTeacherService } from '../../services/class_booking/classBookingServices';
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices';
import SettingsMenu from '../staticscreens/SettingsMenu';
import { CiViewTable } from "react-icons/ci";
import { GetBatchesSlotService } from '../../services/class_booking/batchesSlotServices'

function BatchSubscriptionList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)



  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  const [teachers, setteachers] = useState([])
  const [batches_slots,setbatches_slots] = useState([])


  const mode = ['Online','Offline','All Data']


  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false, teacher:'' })
  const [step,setstep] = useState('Online')

  useEffect(() => {
    getdata()
    getBatches(step == 'Online' ? 'online' : step == 'Offline' ? 'offline' : 'all')
  }, [page,step])

   async function getBatches(mode){
      const response1 = await GetBatchesSlotService(mode ?? data?.mode?.value ?? data?.mode)
        let arr1 = [];
    
        response1?.data?.datas?.forEach((d) => {
          arr1.push({
            label: `${formatTo12Hour(d?.start_time)} - ${formatTo12Hour(d?.end_time)}`,
            value: d?._id,
          });
        });
        setbatches_slots(arr1);
  
    }

  async function getdata() {
    const response = await GetPersonalTrainingSubscriptionTeacherService({ page, teacher: search?.teacher, mode: step,batch: search?.batch });
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherService({ page: 1, teacher: search?.teacher, mode: step, batch: search?.batch })
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'',teacher:'',batch:'' })
    setpage(1)
    const response = await GetPersonalTrainingSubscriptionTeacherService({ page: 1, teacher: '', mode: step, batch: '' })
    setdata(response?.data)
  }

  const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
  };


  async function deleteData() {
    const response = await DeletePersonalTrainingSubscriptionTeacherService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  async function searchTeacher(e){
    const response = await GetTeacherSearchService(e,1,'Batch')
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setteachers(arr)
  }

  console.log("data",data)

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <SettingsMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Batch Booking ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <div className='mr-2 flex items-center mt-1 md:mt-0'>
               {roles?.includes('admin') &&
                <div className='mr-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.teacher == '' ? null : search?.teacher}
                  bordered={false}
                  onSearch={searchTeacher}
                  className='border rounded-[5px] h-[26px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={teachers}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Teacher</span>}
                  onChange={(e)=>setsearch({...search,teacher:e})}
                  />
              </div>}  
               
                <div className='mr-2 w-[160px]'>
                  <Select
                    value={search?.batch == '' ? null : search?.batch} 
                    filterOption={false}
                    bordered={false}
                    options={batches_slots}
                    placeholder={<span className="text-[12px] text-gray-300 ">Select Batch</span>}
                    onChange={(e)=>setsearch({...search,batch:e})} 
                    className='border rounded-[5px] h-[26px] border-slate-300 w-[100%] place-holder:text-[10px]'
                    />
                </div>

                <input id="search_text" placeholder='Search text' type='text' value={search.text1} onChange={(e) => setsearch({ ...search, text1: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigator('create')} />
              </div>
            </div>
          </div>

           <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
              {mode?.map((s)=>(
              <h6 onClick={()=>{setstep(s);setsearch({...search,batch:''});setpage(1)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
              ))}
            </div>

          <div className='mb-[50px]'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%]'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-y-auto border-t border-l border-r border-b'>
                  <div className='sticky top-0 z-50 flex w-full bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] w-[50px] px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Teacher Info</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-[2] px-2 py-1 font-[600] text-slate-800 border-r'>Student List</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Batch / Class</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Meet Link</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] flex-1 px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50 text-[12px] w-[80px] px-2 py-1 font-[600] text-slate-800 border-r'>Action</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px] bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] w-[50px] px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>

                      <h6 className='text-[12px] break-word flex-1 px-2 py-1 font-[500] border-r'>
                       {d?.mode !== 'online' && d?.class_room?._id && <h6 className='text-[14px] bg-yellow-200 p-1 my-1'>{d?.class_room?.label} [{d?.class_room?.name}]</h6>}
                        <span className='font-bold'>{d?.teacher?.name}</span><br></br>
                        <h6 className='text-[10px] w-max capitalize bg-blue-100 p-1 rounded mt-1'>{d?.mode}</h6><br></br>
                      </h6>
                      <h6 className='text-[12px] break-all flex-[2] px-2 py-1 font-[500] border-r'>
                       <h6 className='text-[11px]'>Total Users : {d?.students?.length}</h6>
                       <div className='flex flex-wrap '>
                       {d?.students?.map((s)=><span className='bg-slate-200 text-[11px] p-[4px] m-[4px]'>{s?.name} - [{s?.mobile}]</span>)}
                       </div>
                      </h6>
                      <h6 className='text-[11px] break-word flex-1 px-2 py-1 border-r'>
                        {formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)} <br></br>
                      </h6>
                      <h6 className='flex break-word flex-1 px-2 py-1 font-[500] border-r'>{d?.remarks}</h6>
                      <h6 className='flex break-word flex-1 px-2 py-1 break-all font-[500] border-r'>{d?.meet_link}</h6>
                      <h6 className='break-word flex-1 px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                      <h6 className='text-[12px] flex items-start w-[80px] px-2 py-1 font-[600] text-slate-800 border-r'>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <CiViewTable onClick={() => navigator('time_table', { state: d })} className='mr-2' />
                        <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.teacher?.name || 'No teacher assigned'}</h6>
                          <h6 className='text-[10px] w-max capitalize bg-blue-100 px-1.5 py-0.5 rounded mt-1'>{d?.mode}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><CiViewTable size={17} onClick={() => navigator('time_table', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => {setselecteddata(d);setmodal(true)}} /></span>
                        </div>
                      </div>

                      {d?.mode !== 'online' && d?.class_room?._id && <h6 className='text-[12px] bg-yellow-100 rounded p-1.5 mt-2'>{d?.class_room?.label} [{d?.class_room?.name}]</h6>}

                      <h6 className='text-[11px] text-slate-600 mt-2'>{formatTo12Hour(d?.batch?.start_time)} - {formatTo12Hour(d?.batch?.end_time)}</h6>

                      <h6 className='text-[11px] mt-2 font-[600]'>Students ({d?.students?.length || 0})</h6>
                      <div className='flex flex-wrap'>
                        {d?.students?.map((s)=><span key={s?._id} className='bg-slate-100 text-[11px] px-1.5 py-1 rounded m-[3px]'>{s?.name} - [{s?.mobile}]</span>)}
                      </div>

                      {d?.remarks && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}
                      {d?.meet_link && <h6 className='text-[11px] mt-1 break-all'><span className='font-[600]'>Meet Link:</span> {d?.meet_link}</h6>}

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default BatchSubscriptionList